import { render } from "./EditIcon.vue?vue&type=template&id=0506ab04&scoped=true"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"

import "./EditIcon.vue?vue&type=style&index=0&id=0506ab04&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0506ab04"]])

export default __exports__